import styles from '../bmweDataTable.module.css';
import { tableStrings } from '../i18n/de-de';

interface DataTableLiveRegionsProps {
  loading: boolean;
  announcement: string;
}

export function DataTableLiveRegions({
  loading,
  announcement,
}: DataTableLiveRegionsProps) {
  return (
    <>
      {loading && (
        <div aria-live="polite" className={styles.srOnly}>
          {tableStrings.messages.loading}
        </div>
      )}
      <div aria-live="assertive" className={styles.srOnly}>
        {announcement}
      </div>
    </>
  );
}
